import React, { useState, useEffect } from 'react'
import MediaLibraryPopup from '../../cmp/MediaLibraryPopup';
import { GetProducts, Alerts } from '../../../helpers';
import ProductGallery from './ProductGallery';
const AddProductMedia = ({ product_id }) => {
    const [showMedia, setShowMedia] = useState(false);
    const [mediaData, setMediaData] = useState([]);
    const getProductMedia = async (pro_id) => {
        let resp = await GetProducts.getProductGallery(pro_id);
        if (resp && resp.status) {
            setMediaData(resp.data);
        }
    };

    useEffect(() => {
        getProductMedia(product_id);
    }, [product_id]);


    const handleImageSubmit = async (medias) => {
 
        if(medias && medias.length > 0){
            const media_ids = medias.map(el => el.id);
            let resp = await GetProducts.createProductGallery({media_ids:media_ids}, product_id);
            if (resp && resp.status) {
                Alerts.alertMessage(resp.message, "top-right", "success");
                getProductMedia(product_id);
                setShowMedia(false);
            } else {
                Alerts.alertMessage(resp.message, "top-right", "error");
            }
        }
    };

    const deleteRecord = async (id) => {
        let resp = await GetProducts.deleteProductGallery(id);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            getProductMedia(product_id);
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }
    return (
        <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                   
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Select your file </label>
                                            <div className="dropzone-box">
                                                <button type="button" onClick={() => setShowMedia(true)} className="choose-btn">Choose file </button>
                                            </div>
                                           
                                        </div>
                                       
                                    </div>
                                </div>
                                {
                                    showMedia && <MediaLibraryPopup show={showMedia} setShowMedia={setShowMedia} handleImageSubmit={handleImageSubmit}/>
                                }
                            
                </div>
                <div className='col-md-12' style={{ marginTop: 20 }}>

                    {
                        mediaData && mediaData.length > 0 && <ProductGallery mediaFiles={mediaData} handleDeleteImage={deleteRecord} />
                    }
                </div>
            </div>



        </div>

    )
}

export default AddProductMedia